import Icon from '../components/Icon.vue'

Icon.register({"clipboard-check":{"width":384,"height":512,"paths":[{"d":"M336 64H256C256 28.7 227.3 0 192 0S128 28.7 128 64H48C21.5 64 0 85.5 0 112V464C0 490.5 21.5 512 48 512H336C362.5 512 384 490.5 384 464V112C384 85.5 362.5 64 336 64zM192 40C205.3 40 216 50.7 216 64S205.3 88 192 88 168 77.3 168 64 178.7 40 192 40zM313.2 271.8L170.2 413.6C165.5 418.3 157.9 418.2 153.2 413.5L70.6 330.2C65.9 325.5 66 317.9 70.7 313.2L99.1 285C103.8 280.3 111.4 280.4 116.1 285.1L162.1 331.5 268.1 226.3C272.8 221.6 280.4 221.7 285.1 226.4L313.3 254.8C318 259.6 317.9 267.1 313.2 271.8z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/clipboard-check.js
// module id = null
// module chunks = 